import { render, staticRenderFns } from "./SvgGrabNode.vue?vue&type=template&id=b4c64b36&scoped=true&lang=pug&"
import script from "./SvgGrabNode.vue?vue&type=script&lang=ts&"
export * from "./SvgGrabNode.vue?vue&type=script&lang=ts&"
import style0 from "./SvgGrabNode.vue?vue&type=style&index=0&id=b4c64b36&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c64b36",
  null
  
)

export default component.exports